import { api } from './api.js';

/** Oficina do usuário logado e convites de mecânico (rotas /v1/workshops e /v1/invitations). */
export const workshops = {
  /** @returns {Promise<{ workshop: any | null, membership: { id: string, role: 'MANAGER' | 'MECHANIC' } | null }>} */
  mine: () => api('GET', '/v1/workshops/mine'),
  create: (data) => api('POST', '/v1/workshops', data),
  update: (patch) => api('PATCH', '/v1/workshops/mine', patch),
  members: () => api('GET', '/v1/workshops/mine/members'),
  removeMember: (id) => api('DELETE', `/v1/workshops/mine/members/${encodeURIComponent(id)}`),
  invitations: () => api('GET', '/v1/workshops/mine/invitations'),
  /** → { invitation, token, url }. O token só vem nesta resposta. */
  invite: (data = {}) => api('POST', '/v1/workshops/mine/invitations', data),
  revokeInvitation: (id) => api('DELETE', `/v1/workshops/mine/invitations/${encodeURIComponent(id)}`),
  getInvitation: (token) => api('GET', `/v1/invitations/${encodeURIComponent(token)}`),
  acceptInvitation: (token) => api('POST', `/v1/invitations/${encodeURIComponent(token)}/accept`),
};

export const WORKSHOP_STATUS = {
  PENDING: { label: 'Em análise', color: 'warning' },
  APPROVED: { label: 'Aprovada', color: 'success' },
  REJECTED: { label: 'Precisa de correção', color: 'danger' },
  BLOCKED: { label: 'Bloqueada', color: 'medium' },
};

/** Aceita o link inteiro (…/convite/<token>) ou só o código. Devolve o token ou ''. */
export function parseInviteToken(value) {
  const s = String(value ?? '').trim();
  const m = s.match(/convite\/([A-Za-z0-9_-]+)/);
  const token = m ? m[1] : s;
  return /^[A-Za-z0-9_-]{16,128}$/.test(token) ? token : '';
}
